import { render } from "./McDonalds.vue?vue&type=template&id=277489e0&scoped=true"
const script = {}

import "./McDonalds.vue?vue&type=style&index=0&id=277489e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-277489e0"

export default script